export class TransactionLogReqModel{
     actionType?:string[];
     category?:string;
     couponCode?:string;
     fromActionDate?:string;
     lmt?:number;
     offset?:number;
     toActionDate?:string;
     source?:string;
}